// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit-element';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
:host([hidden]) {
  display: none; }

:host {
  display: block;
  --default-font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  --theme-primary-color: #0078d7;
  --theme-dark-color: #005a9e; }

.ms-Icon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin: 4px 0; }

.ms-Icon--ChevronDown::before {
  content: '\\\E70D'; }

.ms-Icon--ChevronUp::before {
  content: '\\\E70E'; }

.ms-Icon--Contact::before {
  content: '\\\E77B'; }

.ms-Icon--AddFriend::before {
  content: '\\\E8FA'; }

.ms-Icon--OutlookLogoInverse::before {
  content: '\\\EB6D'; }

:host,
mgt-arrow-options {
  position: relative;
  font-family: var(--default-font-family); }

:host .ArrowIcon,
mgt-arrow-options .ArrowIcon {
  font-family: 'FabricMDL2Icons';
  margin: 0 0 0 20px;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none; }

:host .Header,
mgt-arrow-options .Header {
  cursor: pointer; }

:host .Header:hover,
mgt-arrow-options .Header:hover {
  color: var(--theme-primary-color);
  background-color: var(--background-color--hover); }

:host .Menu,
mgt-arrow-options .Menu {
  position: absolute;
  left: 0;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 40px 5px;
  background: #ffffff;
  z-index: 1;
  display: none;
  color: black;
  white-space: nowrap; }

:host .Menu.Open,
mgt-arrow-options .Menu.Open {
  display: block; }

:host .MenuOption,
mgt-arrow-options .MenuOption {
  padding: 20px;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  display: flex;
  align-items: center;
  justify-content: stretch;
  justify-items: stretch; }

:host .MenuOption:first,
mgt-arrow-options .MenuOption:first {
  padding: 12px 20px 20px 20px; }

:host .MenuOption:hover,
mgt-arrow-options .MenuOption:hover {
  background: #c0c0c0; }

:host .MenuOption:active,
mgt-arrow-options .MenuOption:active {
  background: #d8d8d8; }

:host .MenuOptionCheck,
mgt-arrow-options .MenuOptionCheck {
  font-family: 'FabricMDL2Icons';
  color: rgba(0, 0, 0, 0);
  margin-right: 10px; }

:host .MenuOptionCheck.CurrentValue,
mgt-arrow-options .MenuOptionCheck.CurrentValue {
  color: #0078d4; }

`
];
